<template>
  <div>
    <h3>Puertas de acceso</h3>
    <DataTable
      :config="config"
      :data="puertasAcceso"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    >
    </DataTable>

    <modal
      v-model="showModal"
      :key="formIndex"
      :disableScroll="true"
      :showFooter="false"
      :title="titleModal"
    >
      <PuertasAccesoForm
        :areas="areasSeguridad"
        :dataEdit="dataEdit" 
        @successData="getSuccessData"
        @toggleModal="toggleModal"
      ></PuertasAccesoForm>
    </modal>
  </div>
</template>

<script>
import PuertasAccesoForm from "./PuertasAccesoForm.vue";
import DataTable from "../../MainComponents/DataTable.vue";

export default {
  name: "PuertasAcceso",
  components: {
    PuertasAccesoForm,
    DataTable,
  },
  data() {
    return {
      puertasAcceso: [],
      areasSeguridad: [],

      formIndex: 1,
      showModal: false,
      dataEdit: [],
      editMode: false,

      titleModal: "",

      config: {
        selectableRow: true,
        allowExport: false,
        rawText: "Puertas de acceso",
        orderByCol: { Field: "nombreZona", Type: "Asc" },
        selectConfig: {
          idRowData: "id",
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addAcceso",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editAcceso",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteAcceso",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },
          {
            text: "Ip de Puerta",
            value: "ip",
          },
          {
            text: "Zona",
            value: "nombreZona",
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addAcceso") {
        this.titleModal = "Añadir Puerta de Acceso";
        this.showForm();
      }
      if (buttonId == "editAcceso") {
        this.titleModal = "Editar Puerta de Acceso";
        this.showEditForm(idSelected[0]);
      }
      if (buttonId == "deleteAcceso") {
        this.deleteAcceso(idSelected[0]);
      }
    },
    async getPuertas() {
      this.puertasAcceso = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "SGD/Puertas"
        );

      if (snapshot.exists()) {
        let puertas = Object.entries(snapshot.val());
        puertas.forEach((element) => {
          this.puertasAcceso.push({
            id: element[0],
            nm: element[1].nm,
            ip: element[1].ip,
            zn: element[1].zn,
          });
        });
        // Generar un mapa clave-valor para tener los nm a mano
        const mapaAreas = new Map(
          this.areasSeguridad.map((area) => [area.id, area.nm])
        );
        // Colocar el nombre de la zona
        this.puertasAcceso.forEach((PA) => {
          PA.nombreZona = mapaAreas.get(PA.zn) || "Zona no encontrada";
        });
      }
    },
    async getAreas() {
      this.areasSeguridad = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "SGD/Zonas"
        );

      if (snapshot.exists()) {
        let zonas = Object.entries(snapshot.val());
        zonas.forEach((element) => {
          this.areasSeguridad.push({ id: element[0], nm: element[1].nm });
        });
      }
    },
    showForm() {
      this.formIndex++;
      this.editMode = false;
      this.dataEdit = false;
      this.showModal = true;
    },
    showEditForm(id) {
      this.formIndex++;
      this.editMode = true;
      this.dataEdit = this.$pgsHelper.getById(this.puertasAcceso, "id", id);
      this.showModal = true;
    },

    toggleModal(open) {
      this.showModal = open;
    },
    getSuccessData(data) {
      let dataAcceso = {
        nm: data.nombrePuerta,
        ip: data.ip,
        zn: data.zonaSeguridad,
      };

      if (data.edit == "" || !data.edit) {
        this.saveAcceso(dataAcceso);
      } else {
        dataAcceso.Id = data.id;
        this.editAcceso(dataAcceso);
      }
    },

    saveAcceso(data) {
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas guardar esta puerta de acceso?",
        text: "La puerta de acceso se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("SGD-Puertas-createPuerta", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Puerta de acceso Guardada",
              "La puerta de acceso se almaceno correctamente",
              "success"
            );
            this.getPuertas();
            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editAcceso(data) {
      this.$pgsHelper.log("data", data);
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas editar esta Puerta de acceso?",
        text: "La Puerta de acceso se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("SGD-Puertas-updatePuerta", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Puerta de acceso Guardada",
              "La Puerta de acceso se almaceno correctamente",
              "success"
            );
            this.getPuertas();
            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteAcceso(ID) {
      if (ID != "WEB" && ID != "GLOBAL") {
        let data = { Id: ID, force: true };
        data.Departamento = this.MainDepartamento;

        this.$swal({
          title: "¿Deseas eliminar esta Puerta de acceso?",
          text: "Se eliminará su información permanentemente",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Eliminar",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            return await this.$store.getters.getFirebaseApp.fba
              .call("Alguna-Función", data)
              .then((result) => {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              this.$swal(
                "Puerta de acceso iliminada",
                "La Puerta de acceso se elimino correctamente",
                "success"
              );
            } else {
              this.$swal(
                "Error al guardar los datos",
                "No se guardaron los datos",
                "error"
              );
            }
          }
        });
      } else {
        this.$swal(
          "Error al guardar los datos",
          "No se puede eliminar LA Puerta de acceso " + ID,
          "error"
        );
      }
    },
  },
  async mounted() {
    await this.getAreas();
    await this.getPuertas();
  },
};
</script>
